(function($){
    $(document).ready(function(){		//when DOM is ready
        pandora.init();
    });
	window.addEventListener("load", function() { pandora.initImageResize(); }, false); 
	setTimeout(function() { pandora.initImageResize(); }, 5000);
	$(window).resize(function() {
		pandora.initImageResize();
		pandora.resizeHomepageSlider();
		pandora.adjustCollectionItemHeight();
		pandora.adjustFooterPadding();
		pandora.adjustSliderNavPos();
	});	
})(jQuery);

var pandora = {
	activeQuickshop: null,
	quickshopCache: null,
	currentVariantOptions: null,
	productImageAlts: null,
	slideChanged: false,
	assoc_product_variant_image: false,
	resizableImages: [
		'.image-collection-item',
		'.image-collection-item-small',
		'.product-image-large',
		'.product-image-small',
		'.image-collection-item-extra-small',
		'.product-image-quickshop'
	],
	imageSizes: {
		'.image-collection-item': {
			'pc': { width: 227, height: 227 },
			'tablet': { width: 227, height: 227 },
			'mobile': { width: 300, height: 300 },
		},
		'.image-collection-item-small': {
			'pc': { width: 300, height: 300 },
			'tablet': { width: 300, height: 300 },
			'mobile': { width: 300, height: 300 },
		},
		'.image-collection-item-extra-small': {
			'pc': { width: 99, height: 99 },
			'tablet': { width: 99, height: 99 },
			'mobile': { width: 99, height: 99 },
		},
		'.product-image-large': {
			'pc': { width: 470, height: 470 },
			'tablet': { width: 312, height: 312 },
			'mobile': { width: 300, height: 300 },
		},
		'.product-image-small': {
			'pc': { width: 70, height: 70 },
			'tablet': { width: 70, height: 70 },
			'mobile': { width: 70, height: 70 },
		},
		'.product-image-quickshop': {
			'pc': { width: 311, height: 311 },
			'tablet': { width: 311, height: 311 },
			'mobile': { width: 311, height: 311 },
		},
		
	},
	init: function() {
		this.initScrollTop();
		this.initFormElements();
		this.adjustFooterPadding();
		this.initUserAuthMenu();
		this.initHomepageSlider();
		this.adjustSliderNavPos();
		this.hideResizableImages();
		this.adjustCollectionItemHeight();
		this.initNavigationSelector();
		this.initSingleProductImageSlider();
		this.initProductLightbox();
		this.initCart();
		this.initQuickShop();
		this.initAccountLogin();
		this.initAddressManage();
	},
	initScrollTop: function() {
		$('.back-to-the-top').click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	},
	initFormElements: function() {
		if($("select:not(.no-uniform)").length > 0) {
			$("select:not(.no-uniform)").uniform();
		}

		$('._product-purchase-btn').click(function() {
			if($(this).attr('disabled') != 'disabled')
			{
				var productId = $(this).parents('.item-info').attr('id');
				productId = productId.match(/\d+/g);
								
				if(window._add_to_cart_ajax === 'false')
				{
					$('#product-actions-' + productId).submit();	
				}
				else
				{
					var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
					if(!variant_id)
					{
						variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
					}
					var quantity = $('#product-actions-' + productId + ' select[name=quantity]').val();
					
					pandora.initAjaxAddToCart(variant_id, quantity);
				}
			}
			return false;
		});
		$('.form-submit-btn').click(function(){
			$(this).parents('form').submit();
		});
	},
	customFormElements: function(selector) {
		$(selector).uniform();
	},
	initNavigationSelector: function() {
		var selector = $('.navigationSelector');
		if(selector.length > 0)
		{
			selector.change(function(){
				window.location = $('option:selected', $(this)).attr('value');
			});
		}
	},
	adjustFooterPadding: function() {
		var mainfooterwrapper = $('.main-footer-wrapper');
		$('.main-content-wrapper').css({ paddingBottom: mainfooterwrapper.height() });
	},
	initUserAuthMenu: function() {
		$('.main-header .menu .account').not('._logged-in').click(function(){
			if($('._user_auth').is(':visible'))
			{
				$('._user_auth .password').css('visibility', 'hidden');	//hack to prevent "forget" from showing while runnin slideup animation
				$('._user_auth').slideUp(500, function(){
					$('._user_auth .password').css('visibility', 'visible');
				});
			}
			else
			{
				$('._user_auth').slideDown(500);
			}
			return false;
		});
	},
	initImageResize: function() {	
		var type = pandora.getCurrentResponsiveType();
				
		for(var i in pandora.resizableImages)
		{
			var item = pandora.resizableImages[i];
			this.resizeImageCollection($(item), pandora.imageSizes[item][type].width, pandora.imageSizes[item][type].height);
		}
	},
	resizeImageCollection: function(collection, maxWidth, maxHeight) {
		if(collection.length > 0) {
			collection.each(function() {				
				var params = {
					maxWidth: maxWidth,
					maxHeight: maxHeight
				};
				pandora.resizeImage($(this), params);
			});
		}
	},
	resizeImage: function(item, params) {

		maxWidth = params.maxWidth;
		maxHeight = params.maxHeight;
		item.attr('style', '');	//reset previous styles

		if( params.currHeight != null) { height = params.currHeight; }
		else { height = item.height(); }

		if( params.currWidth != null) { width = params.currWidth; }
		else { width = item.width(); }
		
		//resize
		var h_q = (maxHeight / height);
		var w_q = (maxWidth / width);
		
		if(w_q >= h_q && width > maxWidth) { 
			height = height * w_q;
			item.css('width', maxWidth + 'px');
			width = maxWidth;
			
		} else if(w_q < h_q && height > maxHeight) {
			width = width * h_q;
			item.css('height', maxHeight + 'px');
			height = maxHeight;
		}
				
		//reposition
		if(width > 0) { 
			var diff = parseInt((maxWidth - width)/2);
			item.css('position', 'absolute');
			item.css('left', diff + 'px');
		}
		if(height > 0) { 
			var diff = parseInt((maxHeight - height)/2);
			item.css('position', 'absolute');
			item.css('top', diff + 'px');
		}

		item.show();
	},
	hideResizableImages: function() {
		for(i in this.resizableImages) {
			$(this.resizableImages[i]).hide();
		}
	},
	initHomepageSlider: function() {
		if($('.template-index').length > 0) {
			
			var timeout = parseInt(window._slider_timeout);
			if(typeof timeout == "undefined")
			{
				timeout = 0;
			}

			$('#hompage-slider_content').cycle({
				fx: 'fade',
				speed: '600',
				timeout: timeout,
				prev:   '.previous', 
				next:   '.next',
				pager: '#pager',
				activePagerClass: "active",
				easing: 'swing',
				slideResize: 0,
				containerResize: 1,
				slideExpr: '.item',
				pause: true,
				pagerAnchorBuilder: function(idx, slide) {  return ''; }
			});

            if($('#hompage-slider_content').children('.item').length <= 1)
            {
                $('#hompage-slider_content .blank-item').hide();
                $('.homepage-slider .navigation').hide();
            }

			$('#pager a').click(function(){
				var index = $('#pager a').index($(this));
				$('#hompage-slider_content').cycle(index);
				return false;
			});
			
			$('#hompage-slider_content').touchwipe({
			    wipeLeft: function() { $('#hompage-slider_content').cycle('next'); },
			    wipeRight: function() { $('#hompage-slider_content').cycle('prev'); },
				wipeUp: function() { return false; },
				wipeDown: function() { return false; },
			    min_move_x: 20,
			    min_move_y: 20,
			    preventDefaultEvents: false
			});
		}
	},
	adjustSliderNavPos: function() {
		if($('.template-index').length > 0) {
			var nav = $('.main-slider nav');
			var nav_width = nav.outerWidth();
			var scr_width = $(window).width();
			nav.css('left', (scr_width-nav_width)/2);
		}
	},
	resizeHomepageSlider: function() {
		if($('.template-index').length > 0) {
			$('#hompage-slider_content .item, #hompage-slider_content').width($('body').width());
		}
	},
	getCurrentResponsiveType: function() {
		var window_w = $(window).width();
		if(window_w > 767 && window_w < 959 ) {	//ipad
			type = 'tablet';
		} else if(window_w <= 767) {	//iphone
			type = 'mobile';
		} else {	//full
			type = 'pc';
		}
		return type;
	},
	adjustCollectionItemHeight: function() {
		var type = pandora.getCurrentResponsiveType();

		var items = $('.items ._collection-item');
		if(items.length > 0)
		{	
			var columns = 4;	//normal
			if(type == 'tablet') { columns = 3; }	//tablet
			if(type == 'mobile') { columns = 1; }	//mobile

			pandora.resizeRowItemHeight(items, columns);
		}
	},
	resizeRowItemHeight: function(items, columns) {
		var chunks = chunk(items, columns);
		
		for(var row in chunks)
		{
			var maxHeight = Math.max.apply(null, chunks[row].map(function ()
			{
				var height = $(this).find('.image-wrapper').innerHeight() + $(this).find('h2').innerHeight() + $(this).find('.price').innerHeight();
				return height + 8;
			}).get());
			chunks[row].height(maxHeight);
		}
	},
	initSingleProductImageSlider: function() {
		if($('.template-product').length > 0) {
						
			$('#_single-product-slider').cycle({
				fx: 'scrollHorz',
				speed: '600',
				timeout: 0,
				easing: 'swing',
				slideResize: 0,
				containerResize: 1,
				slideExpr: '.image'
			});

			var navBtns = $('.thumbnails div a')
			navBtns.click(function(){
				var index = navBtns.index($(this));
				navBtns.removeClass('active');
				$(this).addClass('active');
				pandora.slideChanged = false;
				if(!pandora.slideChanged)
				{
					$('#_single-product-slider').cycle(index);
				}
				return false;
			});
			
			var navBtns = jQuery('.main-item .thumbnails ul a');
			navBtns.click(function(){
				var index = navBtns.index(jQuery(this));
				navBtns.removeClass('active');
				jQuery(this).addClass('active');
				pandora.slideChanged = false;
				jQuery('#_single-product-slider').cycle(index);
				return false;
			});
			
			jQuery('.main-item .thumbnails ul').jcarousel();
			
		}
	},
	initCart: function() {
		if($('.template-cart').length > 0)
		{
			$('#cart_submit').click(function(){
				$('.__checkout-btn').trigger('click');
				return false;
			});
			
			$('#cart_update').click(function(){
				$('.__update-btn').trigger('click');
				return false;
			});
			
			
			// + 1 quantity
			$('.main-cart .quantity .more').click(function(){
				var quantity = $(this).siblings('input[type=text]');
				var newQuantity = parseInt(quantity.val()) + 1;
				quantity.val(newQuantity);
				
				var row = $(this).parents('.row');
				var variant_id = row.attr('id');
				Shopify.changeItem(variant_id, newQuantity, function(cart){
					$('.main-cart .total p').html(Shopify.formatMoney(cart.total_price, window._money_format));
				});
				
				return false;
			});
			
			// - 1 quantity
			$('.main-cart .quantity .less').click(function(){
				var quantity = $(this).siblings('input[type=text]');
				var oldQuantity = parseInt(quantity.val());
				if(oldQuantity > 1)
				{
					var newQuantity = oldQuantity - 1;
					quantity.val(newQuantity);
					
					var row = $(this).parents('.row');
					var variant_id = row.attr('id');
					Shopify.changeItem(variant_id, newQuantity, function(cart){
						$('.main-cart .total p').html(Shopify.formatMoney(cart.total_price, window._money_format));
					});
				}
				return false;
			});
			
			//allow only numbers to be entered in quantity box
			$('.main-cart .quantity input[type=text]').keydown(function(event) {
		        // Allow: backspace, delete, tab and escape
		        if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27
			 		|| 
		            (event.keyCode == 65 && event.ctrlKey === true) 
					|| 
		            (event.keyCode >= 35 && event.keyCode <= 39)) {
		                 return;
		        }

		        // Ensure that it is a number and stop the keypress
		        if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
		            event.preventDefault(); 
		        }   
			});
			
			//remove item from cart
			$('.main-cart .delete button').click(function(){
				var row = $(this).parents('.row');
				var variant_id = row.attr('id');
				Shopify.removeItem(variant_id, function(){
					row.slideUp(500, function(){
                      row.remove();
                    });
					pandora.updateCartAmounts();
				});
				return false;
			});
		}
	},
	initQuickShop: function() {		
		$('._quick-shop-launcher').click(function(){
			
			var product_handle = $(this).attr('id');
			var template = $('#quickshop-template').html();
						
			Shopify.getProduct(product_handle, function(product){				
				//strip description from html and trim lenght
				var description = product.description.replace(/<(?:.|\n)*?>/gm, '');
				var description = description.substr(0, 200);
				description = description.substr(0, Math.min(description.length, description.lastIndexOf(" ")));
				description = description + '...';				
								
				template = template.replace(/\[\[PRODUCT_ID\]\]/g, product.id);
				template = template.replace(/\[\[PRODUCT_URL\]\]/g, product.url);
				template = template.replace(/\[\[TITLE\]\]/g, product.title);
				template = template.replace(/\[\[DESCRIPTION\]\]/g, description);
				template = template.replace(/\[\[FULLSIZE_IMAGE_LINK\]\]/g, product.featured_image);
								
				//if available
				if(product.available)
				{
					template = template.replace(/\[\[PRICE\]\]/g, Shopify.formatMoney(product.price, window._money_format));

					//if price varies
					if(product.price_varies)
					{
						template = template.replace(/\[\[OLD_PRICE\]\]/g, Shopify.formatMoney(product.price_max, window._money_format));
					}
					else
					{
						template = template.replace(/<s>\[\[OLD_PRICE\]\]<\/s>/g, '');
					}
				}
				else
				{
					template = template.replace(/\[\[PRICE\]\]/g, '');
					template = template.replace(/<s>\[\[OLD_PRICE\]\]<\/s>/g, '');
				}
				
				var template_obj = $(template);
				
				/****** INSERT ******/
				$('.quick-shop').html(template_obj);
				pandora.adjustQuickShopPopupPosition();
				
				/****** VARIANTS *******/
				pandora.createQuickshopVariants(product, template_obj);
				
				/****** SOLD OUT *******/
				if(!product.available)
				{
					template_obj.find('.sold-out').show();
					template_obj.find('.buy').hide();
				}
				
				/****** IMAGE *******/
				pandora.loadQuickShopImage(product, template_obj);
				
				/****** CAROUSEL *******/

				pandora.loadQuickShopCarousel(product, template_obj);
				
				/****** EVENTS *******/
				pandora.initQuickshopAddToCart();
				
				/****** SHOW ******/
				$('.lightbox').show();	//IE does not allow to fadein transparent stuff
				$('.quick-shop').fadeIn(350);
				
			});
						
			return false;
		});
		
		$('.lightbox, .close-window').live('click', function(){
			pandora.closeQuickShopPopup();
			return false;
		});
		
		$(window).resize(function(){
			pandora.adjustQuickShopPopupPosition();
		});
	},
	initQuickshopAddToCart: function() {
		
		$('.ajax-form-submited-wrap').hide();
		
		$('.quick-shop ._product-purchase-btn').click(function(){
		
			var variant_id = $('.quick-shop select[name=id]').val();
			if(!variant_id)
			{
				variant_id = $('.quick-shop input[name=id]').val();
			}
			var quantity = $('.quick-shop select[name=quantity]').val();
			
			pandora.initAjaxAddToCart(variant_id, quantity);
		});
	},
	initAjaxAddToCart: function(variant_id, quantity) {
		$.ajax({
			type: "post",
			url: "/cart/add.js",
			data: 'quantity=' + quantity + '&id=' + variant_id,
			dataType: 'json',
			beforeSend: function() {
				$('.ajax-form-submited-wrap .ajax-form-loader').show();
				$('.ajax-form-submited-wrap').fadeIn(500);
			},
			success: function( msg ) {
				$('.ajax-form-submited-wrap .ajax-form-loader').fadeOut(500, function(){
					$('.ajax-form-submited-wrap .ajax-form-submited-success').fadeIn(500);
				});
				
				pandora.updateCartAmounts();
			},
			error: function(xhr, text) {
				$('.ajax-form-submited-error').text($.parseJSON(xhr.responseText).description);
				$('.ajax-form-submited-wrap .ajax-form-loader').fadeOut(500, function(){
					$('.ajax-form-submited-wrap .ajax-form-submited-error').fadeIn(500);
				});
			},
			complete: function() {
				$('.ajax-form-submited-wrap').delay(3000).fadeOut(500, function(){
                    $('.ajax-form-submited-wrap .ajax-form-submited-success').fadeOut(500);
					$('.ajax-form-submited-wrap .ajax-form-submited-error').fadeOut(500);
				});
			}
		});
	},
	updateCartAmounts: function() {
		Shopify.getCart(function(cart){
			var cart_text = cart.item_count + ' items (' + Shopify.formatMoney(cart.total_price, window._money_format) + ' in total)';
			$('.main-header .menu .cart').html(cart_text);
			
			//on cart page
			if($('body').hasClass('template-cart'))
			{
				$('.main-cart .total p').html(Shopify.formatMoney(cart.total_price));
			}
			
		});
	},
	loadQuickShopImage: function(product, template_obj) {
		if(product.featured_image)
		{
			var image = Shopify.resizeImage(product.featured_image, 'large');
			
			//load image async					
			var quickImage = new Image();
			quickImage.onload = function() {
				template_obj.find('.image a').eq(0).append(quickImage);
				
				var params = {
					maxWidth: 311,
					maxHeight: 311,
					currWidth: quickImage.width,
					currHeight: quickImage.height
				};	
				pandora.resizeImage($('.product-image-quickshop', '.quick-shop' ), params);		
			};
			quickImage.src = image;
			quickImage.className += 'product-image-quickshop';
			quickImage.alt = product.title;
		}
		
		//resize image
		var params = {
			maxWidth: 311,
			maxHeight: 311,
			currWidth: quickImage.width,
			currHeight: quickImage.height
		};
		
		pandora.loadQuickShopSlider(product, template_obj);
		pandora.resizeImage($('.product-image-quickshop', '.quick-shop' ), params);
	},
	loadQuickShopSlider: function(product, template_obj) {
		if(product.images.length > 1)
		{
			for(i in product.images)
			{
				if(i == 0) continue;
				var large = Shopify.resizeImage(product.images[i], '1024x1024');
				var item = '<div class="image">' +
					'<a href="' + product.images[i] + '" class="lightbox-launcher"><img src="' + large + '" alt="" class="product-image-quickshop" /></a>' +
				'</div>'; 
				
				template_obj.find('#_quickshop-slider').append(item);
			}
						
			template_obj.find('#_quickshop-slider').cycle({
				fx: 'scrollHorz',
				speed: '600',
				timeout: 0,
				easing: 'swing',
				slideResize: 0,
				containerResize: 1,
				slideExpr: '.image'
			});
		
		}
	},
	loadQuickShopCarousel: function(product, template_obj) {
		if(product.images.length > 1)
		{
			for(i in product.images)
			{
				var image = Shopify.resizeImage(product.images[i], 'compact');
				var item = '<li><a href="#"><img src="' + image + '" alt="" /></a></li>';
				template_obj.find('.thumbnails ul').append(item);
			}
			
			template_obj.find('.thumbnails ul').jcarousel();
			
			var navBtns = template_obj.find('.thumbnails ul a');
			navBtns.first().addClass('active');
			navBtns.click(function(){
				var index = navBtns.index(jQuery(this));
				navBtns.removeClass('active');
				jQuery(this).addClass('active');
				pandora.slideChanged = false;
				jQuery('#_quickshop-slider').cycle(index);
				return false;
			});
		}
		else	//hide
		{
			template_obj.find('.thumbnails').remove(); //thumbnails
		}
	},
	createQuickshopVariants: function(product, template_obj) {
		if(product.variants.length > 1) //multiple variants
		{
			for(var i = 0; i < product.variants.length; i++)
			{
				var variant = product.variants[i];
				var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
				template_obj.find('form.variants > select').append(option);
			}
			
			/****** FORM ELEMENTS ******/
			new Shopify.OptionSelectors("product-select-" + product.id, { product: product, onVariantSelected: selectCallback });
			pandora.customFormElements('#product-actions-' + product.id + ' select:not(.no-uniform)');
			pandora.customFormElements('#quantity-' + product.id);

			/****** ADD LABEL TO SINGLE OPTION, MULTIPLE VARIANT CASE ******/
			if(product.options.length == 1)
			{
				$('.selector-wrapper:eq(0)').prepend('<label for="ProductSelect-option-0">' + product.options[0].name + '</label>');
			}

			/****** FIX SHOPIFY LABELS ******/
			template_obj.find('form.variants .selector-wrapper label').each(function(i, v){
				$(this).html(product.options[i].name);
			});
			
		}
		else //single variant
		{
			template_obj.find('form.variants > select').remove();
			var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
			template_obj.find('form.variants').append(variant_field);
			
			//quantity style
			pandora.customFormElements('#quantity-' + product.id);
		}
	},
	adjustQuickShopPopupPosition: function() {
		
		$('.quick-shop').css({
			position: 'fixed',
			left: ($(window).width() - $('.quick-shop').outerWidth())/2,
			top: ($(window).height() - $('.quick-shop').outerHeight())/2,
			"max-height": $(window).height() - 40,
		});	
		
		$('.quick-shop > img').css({
			"max-height": $(window).height() - 40,
		});
	},
	closeQuickShopPopup: function() {
		if(pandora.quickshopCache !== null)
		{
			$('.quick-shop').html(pandora.quickshopCache);
			pandora.quickshopCache = null;
			pandora.adjustQuickShopPopupPosition();
		}
		else
		{
			$('.quick-shop').fadeOut(350);			//close popup
			$('.lightbox').hide();
			var quickShopItem = $('#' + pandora.activeQuickshop);
			quickShopItem.html( $('.quick-shop').html() );		//replace content
			$('.quick-shop').html('');							//clear
			pandora.activeQuickshop = null;
		}
	},
	initProductLightbox: function() {
		$('.lightbox-launcher').live('click', function(){
			var elem = $(this);
			var imgSrc = elem.attr('href');
			$('.lightbox').show();
			
			if($('.quick-shop').is(':visible')) //if quick shop is already open
			{
				pandora.quickshopCache = $('.quick-shop').html();
			}
			
			var productImage = new Image();
			productImage.onload = function() {
				$('.quick-shop').html(productImage);
				$('.quick-shop').append('<a href="#" class="close close-image"></a>');
				pandora.adjustQuickShopPopupPosition();
				$('.quick-shop').fadeIn(350, function(){
					pandora.adjustQuickShopPopupPosition();
				});
			};
			productImage.src = imgSrc;
			
			return false;
		});
		
		$('.lightbox, .close-image, .quick-shop > img').live('click', function(){
			pandora.closeQuickShopPopup();
			return false;
		});

		$(window).resize(function(){
			pandora.adjustQuickShopPopupPosition();
		});
	},
	initAccountLogin: function() {
		if($('.template-customers-login').length > 0)
		{
			if (window.location.hash == '#recover') {
				$('#login_form').hide();
				$('#password_recovery').show();
			}
			
			$('#forgot_password').click(function() {
				$('#login_form').fadeOut(200, function(){
					$('#password_recovery').fadeIn(200);
				});
				return false;
			});
		
			$('#login').click(function() {
				$('#password_recovery').fadeOut(200, function(){
					$('#login_form').fadeIn(200);
				});
				return false;
			});
		
			$('#login_submit').click(function() {
				$('#customer_login').submit();
				return false;
			});
		
			$('#recover_submit').click(function() {
				$(this).parents('form').submit();
				return false;
			});
		}
	},
	initAddressManage: function() {
		if($('.template-customers-addresses').length > 0)
		{
			$('.edit-address-btn').click(function(){
				var editForm = 'edit_' + $(this).parents('.row').attr('id');				
				$('#' + editForm ).slideDown(300);
				return false;
			});
			
			$('.address-edit-form-cancel').click(function(){
				$(this).parents('.address-edit-form').slideUp(300);
				return false;
			});
			
		}
	}
}

function chunk (arr, len) {

  var chunks = [],
      i = 0,
      n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, i += len));
  }

  return chunks;
}